<template>
  <div class="fxoption-form">
    <a-form
      ref="formRef"
      :model="localForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="Symbol" name="symbol">
        <a-input v-model:value="localForm.symbol" />
      </a-form-item>
      <a-form-item label="Custodian" name="broker">
        <a-input v-model:value="localForm.broker" />
      </a-form-item>
      <a-form-item label="Bilateral" name="isBilateral">
        <a-checkbox v-model:checked="localForm.isBilateral">Yes</a-checkbox>
      </a-form-item>
      <a-form-item label="Amt" name="amt">
        <a-input-number v-model:value="localForm.amt" style="width: 100%" />
      </a-form-item>
      <a-form-item label="AmtCcy" name="amtCcy">
        <a-select
          v-model:value="localForm.amtCcy"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in currencyList"
            :key="item.currencyCode"
            :value="item.currencyCode"
          >
            {{ item.currencyCode }} - {{ item.currencyDesc }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Exercise Price" name="exercisePrice">
        <a-input-number
          v-model:value="localForm.exercisePrice"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="Exercise Style" name="exerciseStyle">
        <a-select
          v-model:value="localForm.exerciseStyle"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in exerciseStyleList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Maturity Date" name="maturityDate">
        <a-date-picker
          v-model:value="localForm.maturityDate"
          style="width: 100%"
          format="YYYY-MM-DD"
        />
      </a-form-item>

      <a-form-item label="Delivery Date" name="settleDate">
        <a-date-picker
          v-model:value="localForm.settleDate"
          style="width: 100%"
          format="YYYY-MM-DD"
        />
      </a-form-item>

      <a-form-item label="Call Put" name="callPut">
        <a-select
          v-model:value="localForm.callPut"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in callPutList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Settlement Type" name="settlementType">
        <a-select v-model:value="localForm.settlementType">
          <a-select-option
            v-for="item in settlementTypeList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Premium Ccy" name="premiumCcy">
        <a-select
          v-model:value="localForm.premiumCcy"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in currencyList"
            :key="item.currencyCode"
            :value="item.currencyCode"
          >
            {{ item.currencyCode }} - {{ item.currencyDesc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Payout Style" name="payoutStyle">
        <a-select v-model:value="localForm.payoutStyle">
          <a-select-option
            v-for="item in payoutStyleList"
            :key="item"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Barrier Style" name="barrierStyle">
        <a-select v-model:value="localForm.barrierStyle">
          <a-select-option
            v-for="item in exerciseStyleList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Win Start Date" name="winStartDate">
        <a-date-picker
          v-model:value="localForm.winStartDate"
          style="width: 100%"
          format="YYYY-MM-DD"
        />
      </a-form-item>

      <a-form-item label="Win End Date" name="winEndDate">
        <a-date-picker
          v-model:value="localForm.winEndDate"
          style="width: 100%"
          format="YYYY-MM-DD"
        />
      </a-form-item>

      <a-form-item label="Barrier Type1" name="barrier1Type">
        <a-select v-model:value="localForm.barrier1Type">
          <a-select-option
            v-for="item in barrierTypeList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Barrier Direction1" name="barrier1Direction">
        <a-select v-model:value="localForm.barrier1Direction">
          <a-select-option
            v-for="item in barrierDirectionList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Barrier Rate1" name="barrier1Rate">
        <a-input-number
          v-model:value="localForm.barrier1Rate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="Barrier ReRate1" name="barrier1Rebate">
        <a-input-number
          v-model:value="localForm.barrier1Rebate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="Barrier Rebate Ccy1" name="barrier1RebateCcy">
        <a-select
          v-model:value="localForm.barrier1RebateCcy"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in currencyList"
            :key="item.currencyCode"
            :value="item.currencyCode"
          >
            {{ item.currencyCode }} - {{ item.currencyDesc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Barrier Type2" name="barrier2Type">
        <a-select v-model:value="localForm.barrier2Type">
          <a-select-option
            v-for="item in barrierTypeList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Barrier Direction2" name="barrier2Direction">
        <a-select v-model:value="localForm.barrier2Direction">
          <a-select-option
            v-for="item in barrierDirectionList"
            :key="item.desc"
            :value="item.code"
          >
            {{ item.desc }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Barrier Rate2" name="barrier2Rate">
        <a-input-number
          v-model:value="localForm.barrier2Rate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="Barrier ReRate2" name="barrier2Rebate">
        <a-input-number
          v-model:value="localForm.barrier2Rebate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="Barrier Rebate Ccy2" name="barrier2RebateCcy">
        <a-select
          v-model:value="localForm.barrier2RebateCcy"
          allow-clear
          :show-search="true"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in currencyList"
            :key="item.currencyCode"
            :value="item.currencyCode"
          >
            {{ item.currencyCode }} - {{ item.currencyDesc }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Expiry Center" name="expiryCenter">
        <a-select
          v-model:value="localForm.expiryCenter"
          allow-clear
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in expiryCenterList"
            :key="item"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Expiry Time" name="expiryTime">
        <a-time-picker
          v-model:value="localForm.expiryTime"
          style="width: 100%"
          format="HH:mm:ss"
        />
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
import { defineProps, defineExpose, ref, computed } from 'vue'
import { useStore } from 'vuex'
// import { message } from 'ant-design-vue'
// import dayjs from 'dayjs'

const store = useStore()

const props = defineProps({
  leg: {
    type: Object,
    required: true,
  },
  // When true, enforce the same leg fields PETS requires before creating an
  // FX option, since sm-svc builds the BB_TCM from them.
  required: {
    type: Boolean,
    default: false,
  },
})

const localForm = ref(props.leg)
const formRef = ref(null)

const validateSymbol = (_rule, value) => {
  if (!value) return Promise.reject('Please input symbol')
  if (!value.includes('/') && !value.includes(' Index')) {
    return Promise.reject('Please use / to split ccy pair, e.g. USD/KRW')
  }
  return Promise.resolve()
}

const rules = computed(() =>
  props.required
    ? {
        symbol: [{ required: true, validator: validateSymbol }],
        broker: [{ required: true, message: 'Please input custodian' }],
        exercisePrice: [
          { required: true, message: 'Please input exercise price' },
        ],
        maturityDate: [
          { required: true, message: 'Please select maturity date' },
        ],
        callPut: [{ required: true, message: 'Please select call put' }],
        exerciseStyle: [
          { required: true, message: 'Please select exercise style' },
        ],
        settlementType: [
          { required: true, message: 'Please select settlement type' },
        ],
        premiumCcy: [{ required: true, message: 'Please select premium ccy' }],
      }
    : {}
)

defineExpose({
  validate: () => formRef.value?.validate(),
})
const currencyList = computed(() => {
  const currencies = store.getters['reference/getCurrencyList'] || []
  return [...currencies].sort((a, b) =>
    a.currencyCode.localeCompare(b.currencyCode)
  )
})

const wrapperCol = {
  span: 24,
}
const labelCol = {
  span: 8,
  style: { textAlign: 'left' },
}

const settlementTypeList = [
  { code: 'C', desc: 'CASH' },
  { code: 'P', desc: 'PHYSICAL' },
]

const callPutList = [
  { code: 'C', desc: 'CALL' },
  { code: 'P', desc: 'PUT' },
]
const exerciseStyleList = [
  { code: 'E', desc: 'EUROPEAN' },
  { code: 'A', desc: 'AMERICAN' },
]

const payoutStyleList = ['INSTANT', 'SETTLEMENT']

const barrierTypeList = [
  { code: 'I', desc: 'In' },
  { code: 'O', desc: 'Out' },
]

const barrierDirectionList = [
  { code: 'U', desc: 'Up' },
  { code: 'D', desc: 'Down' },
]
const expiryCenterList = [
  'ARBA',
  'ATVI',
  'AUME',
  'AUSY',
  'BEBR',
  'BRSP',
  'CAMO',
  'CATO',
  'CHGE',
  'CHZU',
  'CLSA',
  'CNBE',
  'CZPR',
  'DEDU',
  'DEFR',
  'DKCO',
  'EETA',
  'ESAS',
  'ESMA',
  'EUTA',
  'FIHE',
  'FRPA',
  'GBLO',
  'GRAT',
  'HKHK',
  'HUBU',
  'IDJA',
  'IEDU',
  'ILTA',
  'INMU',
  'ITMI',
  'ITRO',
  'JPTO',
  'KRSE',
  'LBBE',
  'LULU',
  'MXMC',
  'MYKL',
  'NLAM',
  'NOOS',
  'NYFD',
  'NYSE',
  'NZAU',
  'NZWE',
  'PAPC',
  'PHMA',
  'PLWA',
  'PTLI',
  'RUMO',
  'SARI',
  'SEST',
  'SGSI',
  'SKBR',
  'THBA',
  'TRAN',
  'TWTA',
  'USCH',
  'USGS',
  'USLA',
  'USNY',
  'VECA',
  'ZAJO',
]

const filterOption = (input, option) => {
  const key = option?.key ?? option?.value ?? ''
  return String(key).toLowerCase().includes(input.toLowerCase())
}
</script>
